import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/login-logo.png'


_pushScopeId("data-v-15168830")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "logo"
}
const _hoisted_3 = { class: "login_right" }
const _hoisted_4 = {
  key: 0,
  class: "custom-dialog-overlay"
}
const _hoisted_5 = { class: "success-dialog-header" }
const _hoisted_6 = { class: "success-dialog-title" }
const _hoisted_7 = { class: "success-dialog-body" }
const _hoisted_8 = { class: "success-dialog-footer" }
const _hoisted_9 = { class: "lang" }
const _hoisted_10 = { class: "copyright" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phoneLogin = _resolveComponent("phoneLogin")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$route.path.includes('huaweiyun'))
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["content", { 'content-step2': _ctx.isRegistrationStep2 }])
      }, [
        _createVNode(_component_phoneLogin, {
          "authorization-required": _ctx.authorizationRequired,
          "force-corp-auth": _ctx.forceCorpAuth,
          onGoIndex: _ctx.loginSucceeded,
          onRegistrationStepChange: _ctx.handleRegistrationStepChange
        }, null, 8, ["authorization-required", "force-corp-auth", "onGoIndex", "onRegistrationStepChange"]),
        (_ctx.successDialogVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "custom-dialog success-dialog",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.lang('certification.success.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.lang('certification.success.content')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.handleSuccessConfirm,
                    class: "success-confirm-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.lang('certification.success.confirm')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", {
            class: _normalizeClass([!_ctx.isEmail && 'active']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.langChange('zh')))
          }, "中", 2),
          _createElementVNode("span", {
            class: _normalizeClass([_ctx.isEmail && 'active']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.langChange('en')))
          }, "EN", 2)
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.lang('login.copyright')), 1)
  ]))
}